import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
//import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import Main from "./Main";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./contexts/ThemeContext";

const lang = process.env.REACT_APP_DEFAULT_LANGUAGE || "en";

switch (lang) {
  case "es":
    document.title = "Chatbot - tuagentevirtual.ai";
    break;
  case "en":
    document.title = "Chatbot - yourvirtualagent.ai";
    break;
  default:
    document.title = "Chatbot - tuagentevirtual.ai";
    break;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <React.Suspense fallback={<div></div>}>
          <Main />
        </React.Suspense>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
